import React, { Component } from 'react';
import { Form, Input, Checkbox } from 'antd';
import { RightOutlined } from '@ant-design/icons';

import { ClassifyCar } from '../classify-car/classify-car';
import { InputNumber } from '../../../../components/common/input-number';

const dataField = [
    {
        title: 'Loại xe',
        fieldName: 'type_car'
    },
    {
        title: 'Phân loại xe',
        fieldName: 'classify_car'
    },
    {
        title: 'Biển kiểm soát',
        fieldName: 'number_plate',
        validation: /^[A-Z]{3} ?- ?\d{5}$/i,
    },
    {
        title: 'Màu sắc',
        fieldName: 'color',
    },
    {
        title: 'Số chỗ',
        fieldName: 'number_seat'
    },
    {
        title: 'Model',
        fieldName: 'model'
    },
    {
        title: 'Số khung',
        fieldName: 'chassis_no'
    },
    {
        title: 'Số máy',
        fieldName: 'machine_id'
    },
    {
        title: 'Năm sản xuất',
        fieldName: 'manufacture_year'
    },
]

export class CarInformation extends Component {

    state = {
        classifyCar: 'MT',
    }

    handleChangeClassifyCar = classifyCar => {
        this.setState({
            classifyCar
        });
    }

    handleInputNumberPlate = data => {
        this.props.onChangeForm('number_plate', data.target.value.toUpperCase().trim());
    }

    render() {
        const { typeOption, editable } = this.props;
        return <>
            {dataField.map(field => {
                return <Form.Item
                    wrapperCol={15}
                    key={field.fieldName}
                    label={`* ${field.title}::`}
                    name={field.fieldName}
                    rules={field.fieldName === 'classify_car' ? [] :
                        field.fieldName === 'number_plate' ? [
                            {
                                required: true,
                                message: `Vui lòng nhập Biển kiểm soát!`,
                            },
                            {
                                pattern: /[A-Z0-9]*-[A-Z0-9]*/,
                                message: `Vui lòng nhập đúng định dạng Biển kiểm soát!`,
                            },
                        ] : field.fieldName === 'number_seat' ? [
                            ({ getFieldValue }) => ({
                                validator(rule, v) {
                                    if (!v) {
                                        return Promise.reject(`Vui lòng nhập Số chỗ!`);
                                    }
                                    if(v > 100) {
                                        return Promise.reject(`Số chỗ không được phép lớn hơn 100!`);
                                    }
                                    return Promise.resolve();
                                },
                            })
                        ] : [
                                ({ getFieldValue }) => ({
                                    validator(rule, v) {
                                        if (!v) {
                                            return Promise.reject(`Vui lòng nhập ${`${field.title}`}!`);
                                        }
                                        return Promise.resolve();
                                    },
                                })
                            ]}>
                    {field.fieldName === 'classify_car' ?
                        <ClassifyCar
                            typeOption={typeOption}
                            disabled={!editable}
                            onChangeFormValues={this.onChangeFormValues} />
                        : field.fieldName === 'number_seat' || field.fieldName === 'manufacture_year' ?
                            <InputNumber
                                normal={field.fieldName === 'manufacture_year' && true}
                                disabled={!editable}
                                placeholder={`${field.title}`} />
                            : <Input
                                disabled={!editable}
                                placeholder={`${field.title}`}
                                onChange={field.fieldName === 'number_plate' ? this.handleInputNumberPlate : null} />}
                </Form.Item>
            })}
        </>
    }
}